import Component from '../abstracts/Component';
import queryString from 'query-string';
import TrackingComponent from '../components/TrackingComponent';

export default class NewsletterLogic extends Component {

  constructor(compEl) {
    super(compEl);
    this.TrackingComponent = new TrackingComponent();
  }

  // subscribe function
  subscribeToNewsletter(e) {
    // ctx is the new this global
    let ctx = e.event.data;
    // preventing submitting form
    e.event.preventDefault();
    // vars
    let $this = e.event.target; // form
    let url = e.event.target.getAttribute('action'); // form url
    let $submit = ctx.$component.querySelector(ctx.SELECTORS.submitButton);
    // let emailval = $this.find('input[name=email]').val();
    let params = new URLSearchParams(new FormData($this)).toString();
    let newsletterFormWrapper = ctx.$component.querySelector(ctx.SELECTORS.newsletterFormWrapper);

    // modal mode
    /*if ($this.closest('.modal').length) {
      url = url + '?xhr=true';
    }*/

    // adding loading class
    newsletterFormWrapper.classList.add('loading');
    // show spinner loader
    ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, {
      button: $submit,
    });

    // 1st ajax call
    ctx
      .$doAjax({
        type: 'POST',
        url: url,
        data: params
      })
      .done(res => {
        ctx.log('Newsletter modal success...');
        // parse result
        let html = new DOMParser ().parseFromString(res, 'text/html');
        // searching errors
        let error = ( html.querySelector('span.error') !== null  ) ;
        // let doRegister = $this.data('registerUrl') != null && $this.data('registerUrl').length > 0;
        // let isLogged = $this.data('loggedin');
        // let $newContent = $(html).find(ctx.SELECTORS.jsContent);
        let alreadySubcribed = (html.querySelector('div.form-error') !== null);
        // replacing content
        if ( $this.closest(ctx.SELECTORS.jsContent ) !== null  && !error ) {
          $this.closest(ctx.SELECTORS.jsContent).innerHTML = html.querySelector(ctx.SELECTORS.jsContent).innerHTML;
        }
        // error
        if (error) {
          // putting error class
          $this.querySelector(ctx.SELECTORS.inputEmail).classList.add('error');
          let spanError = html.querySelector('span.error');
          // insert error span
          if ($this.querySelector(ctx.SELECTORS.inputEmail).parentNode.querySelector('span.error') == null) {
            $this.querySelector(ctx.SELECTORS.inputEmail).parentNode.appendChild(spanError);
          }
        } else if (!alreadySubcribed) {
          // emit event
          ctx.$emit(ctx.$customEvents.NL_POPUP_EVENTS.subscribed);
          let trackingComponent = new TrackingComponent();
          trackingComponent.trackAction('newsletterSubscribe', $submit.dataset , $submit);
        }



        /*if (!isLogged && !error && $newContent.data('register')) {
          //TODO
          ctx
            .$doAjax({
              url: `${$this.data('registerUrl')}`,
              data: {
                email: emailval,
                afterNewsletter: true
              },
            })
            .done(resp => {
              ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                unsafeContent: resp,
                canScroll: true
              });
              ctx.importComponent("RegistrationComponent");
              ctx.$emit(ctx.$customEvents.VALIDATION.bindValidation);
              //ctx.log(resp);
            })
            .fail(xhr => {
              ctx.log(xhr);
            })
            .always(() => {
              ctx.log('done');
            });

          Cookies.set(ctx.hideCookieKey, 'true', {
            expires: 365,
            path: '/'
          });
        }*/
      })
      .fail(xhr => {
        console.log(`nl submit error:  ${$(this).serialize()}`);
        console.log(xhr);
      })
      .always(() => {
        // removing loading class
        newsletterFormWrapper.classList.remove('loading');
        // hide spinner loader
        ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {
          button: $submit,
        });
      });
  }

  render() {
    this.log('Load logics...');
  }
}
